import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookHeart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBookHeart"><Path d="M6.5 21.5H19.5V2.5H6.5C5.39543 2.5 4.5 3.39543 4.5 4.5V19.5M6.5 21.5C5.39543 21.5 4.5 20.6046 4.5 19.5M6.5 21.5H10M4.5 19.5C4.5 18.3954 5.39543 17.5 6.5 17.5H19.5V12.25" stroke="currentColor"/><Path d="M11.9995 7.65108C13.6181 6.60506 15.5 7.7268 15.5 9.60949C15.4997 12.1213 11.9995 13.5 11.9995 13.5C11.9631 13.4856 8.50034 12.1082 8.5 9.60949C8.5 7.72698 10.381 6.6056 11.9995 7.65108Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconBookHeart;
